<template>
  <q-layout>
    <q-page padding>
      <q-toolbar class="column">
        <q-toolbar-title class="text-5 q-mr-auto q-ma-sm">{{ $t('approve_invoices') }}</q-toolbar-title>
        <q-breadcrumbs class="q-mr-auto q-ma-sm">
          <q-breadcrumbs-el :label="$t('dashboard')" to="/ " />
          <q-breadcrumbs-el :label="$t('approve_invoices')" exact />
        </q-breadcrumbs>
      </q-toolbar>
      <q-separator spaced />

      <header-approve-invoices></header-approve-invoices>
      <InvoiceNFImagePopUp ref="filePopUp" />
      <list-approve-invoices v-on:showNfPopUp="handleShowPopUp"></list-approve-invoices>
    </q-page>
  </q-layout>
</template>

<script>
import HeaderApproveInvoices from '../../components/financial/HeaderApproveInvoices.vue';
import ListApproveInvoices from '../../components/financial/ListApproveInvoices.vue';
import InvoiceNFImagePopUp from '../../components/affiliate/financial/InvoiceNFImagePopUp.vue';

export default {
  name: 'ApproveInvoices',
  methods: {
    handleShowPopUp(row) {
      this.$refs.filePopUp.getNfFileURL(row);
    }
  },

  components: { HeaderApproveInvoices, ListApproveInvoices, InvoiceNFImagePopUp }
};
</script>
